var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 11.25V8.1C7.75 7.7733 7.75 7.60995 7.68642 7.48517C7.63049 7.37541 7.54126 7.28617 7.43149 7.23025C7.30671 7.16667 7.14336 7.16667 6.81667 7.16667H5.18333C4.85664 7.16667 4.69329 7.16667 4.56851 7.23025C4.45874 7.28617 4.36951 7.37541 4.31358 7.48517C4.25 7.60995 4.25 7.7733 4.25 8.1V11.25M10.0833 11.25V2.61667C10.0833 1.96327 10.0833 1.63657 9.95617 1.38701C9.84432 1.16749 9.66584 0.989011 9.44632 0.877159C9.19676 0.75 8.87006 0.75 8.21667 0.75H3.78333C3.12994 0.75 2.80324 0.75 2.55368 0.877159C2.33416 0.989011 2.15568 1.16749 2.04383 1.38701C1.91667 1.63657 1.91667 1.96327 1.91667 2.61667V11.25M11.25 11.25H0.75M4.54167 3.66667H4.5475M7.45833 3.66667H7.46417M4.83333 3.66667C4.83333 3.82775 4.70275 3.95833 4.54167 3.95833C4.38058 3.95833 4.25 3.82775 4.25 3.66667C4.25 3.50558 4.38058 3.375 4.54167 3.375C4.70275 3.375 4.83333 3.50558 4.83333 3.66667ZM7.75 3.66667C7.75 3.82775 7.61942 3.95833 7.45833 3.95833C7.29725 3.95833 7.16667 3.82775 7.16667 3.66667C7.16667 3.50558 7.29725 3.375 7.45833 3.375C7.61942 3.375 7.75 3.50558 7.75 3.66667Z",
    stroke: "#70767B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.cc726ad3d0f22e89358ecf446abc71bc.svg";
export { ForwardRef as ReactComponent };